import React from 'react';
import RouterApp from './Routes';

function App() {
  return (
    <RouterApp />
  );
}

export default App;
